import { Carousel } from 'react-bootstrap'

const SLIDES = [
  {
    id: 1,
    caption: "SOFTAC is a manufacturer of Custom Control Panels, Motor Control Centers, Power Distribution Systems and much more",
    alttext: "Control panel wiring and terminal blocks",
    url: "/images/slider1.webp",
    mobileUrl: "/images/slider1-mobile.webp",
  },
  {
    id: 2,
    caption: "SOFTAC serves many different industries, and specializes in Water, Wastewater, Oil & Gas, and Agriculture",
    alttext: "Image of Schneider Altivar drives, finger duct and terminal blocks",
    url: "/images/slider2.webp",
    mobileUrl: "/images/slider2-mobile.webp",
  },
  {
    id: 3,
    caption: "SOFTAC is a manufacturer of Custom Control Panels, Motor Control Centers, Power Distribution Systems and much more",
    alttext: "Control panel doors with panel mount control operators, monitoring equipment and vents",
    url: "/images/slider3.webp",
    mobileUrl: "/images/slider3-mobile.webp",
  },
  {
    id: 4,
    caption: "SOFTAC serves many different industries, and specializes in Water, Wastewater, Oil & Gas, and Agriculture",
    alttext: "Motor starter mounted in a control panel",
    url: "/images/slider4.webp",
    mobileUrl: "/images/slider4-mobile.webp",
  },
];

const MyCarousel = () => {
  return (
    <Carousel controls={false} className="topCarousel" fade={true}>
      {SLIDES.map((slide, index) =>
        <Carousel.Item key={slide.id}>
          <img
            className="d-block w-100"
            src={slide.url}
            srcSet={`${slide.mobileUrl} 800w, ${slide.url} 1366w`}
            sizes="100vw"
            width="1366"
            height="546"
            alt={slide.alttext}
            loading={index === 0 ? "eager" : "lazy"}
            fetchpriority={index === 0 ? "high" : "auto"}
          />

          <Carousel.Caption>
            <h3>{slide.caption}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      )}
    </Carousel>
  )
}

export default MyCarousel;
